export default "__VITE_ASSET__Be9rlVPN__"